<template>
  <div class="container oci-check-in-out-body">    
    <WasteNumberView/>
    <p></p>
    <b-card class="oci-check-in-out-card">  
        <b-row class="pb-0 justify-content-center">
          <b class="driver-large-text">Drive to:</b>
        </b-row>
        <b-row class="pb-0 justify-content-center">
          <b class="driver-large-text site-address">{{wasteLocation(truncate(bookingDockets.location))}}</b>
        </b-row>                
        <b-row class="pb-1 justify-content-center">
            <b-col cols="12" class="d-flex justify-content-center">
                <feather-icon
                icon="TruckIcon"
                size="60"
                />
            </b-col>
        </b-row>
        <b-row class="pb-1">
          <b-col class="col-5 oci-projects-button-container">
            <b-button
              type="submit"
              @click="GoToPreviousPage"
              class="w-100"
            >
              <feather-icon
                icon="ChevronLeftIcon"
                size="12"
              />              
              Back
            </b-button>
          </b-col>
          <b-col class="col-7 oci-check-in-button-container">
            <b-button
              type="submit"
              @click="GoToNextPage"
              class="w-100"
            >
              Next
              <feather-icon
                icon="ChevronRightIcon"
                size="12"
              />              
            </b-button>
          </b-col>
        </b-row>         
    </b-card>

  </div>
  </template>

<script>
import { mapGetters } from 'vuex'
import { BImg, BCard, BRow, BCol, BForm, BFormGroup, BFormSelect, BInputGroupAppend, BFormInput, BButton, BInputGroup, } from 'bootstrap-vue'
import { bookingsMethods } from '@/components/ui/BookingsFunctions'
import WasteNumberView from '@/views/WasteNumberView.vue'

export default {
  components: {
    BImg,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BButton,
    WasteNumberView,
  },
  data() {
    return {
      reason: '',
    };
  },  
  computed: {
    ...mapGetters({ currentBooking: 'app/getCurrentBookingData' }),
    ...mapGetters({ bookingDockets: 'app/getBookingDocketDetails' }),
    ...mapGetters({ wasteLocations: 'app/getWasteLocations' }),
  },
  mounted() {
    //this.originalVehicleRegistrationNumber = this.bookingDockets.vehicle_registration_number;
  },
  methods: {
    GoToPreviousPage() {
      this.$router.go(-1)
    },
    async GoToNextPage() {
      this.$router.push('/waste_confirm_to_drop')
    },
    truncate(text) {
      if (!text) return '';
      return text.length > 30 ? text.slice(0, 30) + '...' : text;
    },
    wasteLocation(locationId) {
    const match = this.wasteLocations.find(loc => loc.id === locationId)
    return match ? match.address_name : ''
    },
  },  
}
</script>
